<!-- 我的收藏 -->
<template>
  <div class="mine-collection-page" v-cloak>
    <van-nav-bar left-arrow fixed title="我的咨询" id="nav-bar" @click-left="onClickLeft"> </van-nav-bar>
    <!-- 列表 -->

    <!-- 列表 -->
    <div class="list">
      <van-list v-model="loading" :immediate-check="true" :finished="finished" finished-text="没有更多了" @load="getInit">

        <div class="item" v-for="(item, index) in productList" :key="index">

          <div class="img-text-row van-hairline--bottom" @click="setType(item)">

            <div class="row-goods-img">
              <img :src="item.pic" alt="" />
            </div>

            <div class="row-goods-info">
              <p class="row-goods-name"> {{ item.goods_name }}</p>
            </div>
          </div>

          <p class="time" v-if="item.content">{{ item.created_time }}</p>
          <div class="xun-wen van-hairline--bottom" v-if="item.content">
            <p>{{ item.content }}</p>
          </div>

          <p class="time" v-if="item.reply_content">{{ item.reply_time }}</p>
          <div class="hui-da" v-if="item.reply_content">
            <p>{{ item.reply_content }}</p>
          </div>

        </div>
      </van-list>
    </div>

    <van-empty class="custom-image" v-if="productList.length< 1" :image="noCollection" />

  </div>
</template>
  
  <script type="text/babel">
import qs from "qs";
export default {
  name: "mine-collection",
  components: {},
  props: {},
  data() {
    return {
      noCollection: require("../../assets/public/zx-list.png"), 
      radio_icon: require("../../assets/icon/radio.png"), //radio
      radio_active_icon: require("../../assets/icon/radio-active.png"), //radio active
      pageNum: 1,
      pageSize: 10,
      loading: true,
      finished: false,
      //商品
      productList: [
        // {
        //   goods_name: "乐扣乐扣-莹彩蓝轻量保温杯",
        //   goods_id: "12131",
        //   pic: "http://qiniu.zdyxjx.com/product/upload_pic_1608275023065",
        //   content: "咨询内容",
        //   reply_content: "回复内容",
        //   status: "状态",
        //   created_time: "2023-11-1",
        //   reply_time: "2023-11-1",
        // },
        // {
        //   goods_name: "乐扣乐扣-莹彩蓝轻量保温杯",
        //   goods_id: "12131",
        //   pic: "http://qiniu.zdyxjx.com/product/upload_pic_1608275023065",
        //   content: "咨询内容",
        //   reply_content: "",
        //   status: "状态",
        //   created_time: "2023-11-1",
        //   reply_time: "2023-11-1",
        // },
      ],
    };
  },
  watch: { 
  },
  created() {},
  mounted() {
    this.getInit();
  },
  methods: {
    getInit() {
      let _this = this;
      this.$toast.loading();
      let data = {
        page: _this.pageNum,
        limit: _this.pageSize,
      };
      _this.$post("/api/user_consult_list", data, data).then((res) => {
        console.log(res.data);
        _this.loading = false; // 加载状态结束

        if (res.data.code == 0) {
          // console.log(res.data.data);

          let lists = res.data.data;

          if (lists && lists.length > 0) {
            lists = lists.map((item, index) => {
              return Object.assign({}, item, { checked: false });
            });

            console.log(lists);

            if (_this.pageNum == 1) {
              _this.productList = [];
              _this.productList = lists;
            } else {
              _this.productList = _this.productList.concat(lists);
            }
            _this.pageNum++;
            if (lists.length < _this.pageSize) {
              _this.finished = true; // 数据全部加载完成
            }
          } else {
            _this.finished = true; // 数据全部加载完成
          }
          _this.$toast.clear();
        } else {
          _this.$toast.fail(res.data.message);
          _this.finished = true;
        }
      });
    },
    setType(e) {
      console.log(e);
      this.$router.push({ path: `/product-details/${e.goods_id}` });
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>
  
  <style lang="scss">
.mine-collection-page {
  // 空状态
  .custom-image .van-empty__image {
    width: 260px;
    height: 300px;
  }
}
</style>
  
  <style lang="scss" scoped>
.mine-collection-page {
  // height: 100%;
  width: 100%;
  padding: 50px 0;
  background-color: #f9f9f9;
  // 横向

  .item {
    background-color: #fff;
    margin-bottom: 10px;
  }
  .img-text-row {
    width: 100%;
    // height: 125px;
    padding: 5px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;

    .row-goods-img {
      width: 60px;
      height: 60px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .row-goods-info {
      flex: 1;
      //   width: 200px;
      height: 100%;
      padding: 5px 0;
      text-align: left;
      //  background-color: paleturquoise;

      .row-goods-name {
        margin-bottom: 10px;
        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        // line-height: 30px;
        color: #333333;
        letter-spacing: 1px;
        // display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
        // -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
        // overflow: hidden; /*超出的文本隐藏*/
        // text-overflow: ellipsis; /* 溢出用省略号*/
        // -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
      }
    }
  }
}

.xun-wen {
  width: 100%;
  background-color: #fff;
  padding: 10px 50px 10px 0;
  background-image: url("../../assets/public/xunwen.png");
  background-repeat: no-repeat;
  background-position: 99% center;
  background-size: 30px 30px;
  p {
    text-align: right;
    color: #373737;
    line-height: 20px;
    font-size: 14px;
    
    padding: 0  0 0 10px;
  }
}
.time {
  text-align: center;
  color: #cccccc;
  line-height: 20px;
  font-size: 12px;
}
.hui-da {
  width: 100%;
  background-color: #fff;
  padding: 10px 0 10px 50px;
  background-image: url("../../assets/public/huida.png");
  background-repeat: no-repeat;
  background-position: 1% center;
  background-size: 30px 30px;
  p {
    text-align: left;
    color: #373737;
    line-height: 20px;
    font-size: 14px;
    padding: 0 10px 0 0;
  }
}

.btnC:active {
  background-color: rgba(255, 80, 0, 0.7) !important;
}
.list {
  padding-bottom: 50px;
}
</style>
  